import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import MuiAlert from '@material-ui/lab/Alert';
import {connect} from 'react-redux';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Snackbox_component(props){

  function handleClose(){props.setSnackbar(undefined, props.snackbar.type);}

  console.log(props.snackbar, 'SNACKBAR WOOWOWOWOOW');
  if(props.snackbar.type=='notifications'){
    return(<Snackbar open={props.snackbar.open} autoHideDuration={3000} onClose={() =>{props.setSnackbar(undefined)}}
      anchorEl={props.snackbar.anchorEl}
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      TransitionComponent={Slide}
      ContentProps={{style:{backgroundColor:'white',marginTop:'20px'}}}
      message={<Typography color='secondary' style={{position:'relative'}}>{(props.snackbar.icon==undefined)?null:<span>{React.cloneElement(props.snackbar.icon, { color: 'secondary', marginBottom:'-5px', marginRight:'10px'})}</span>}<span>{props.snackbar.message}</span></Typography>}
      onClick={props.snackbar.onClick}
    />
  )
  }else{

    return(
      <Snackbar open={props.snackbar.open} autoHideDuration={15000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={props.snackbar.type}>
            {props.snackbar.message}
          </Alert>
      </Snackbar>
    )
}
}


export default connect(ss, dd)(Snackbox_component);


function ss(state){
  return{
    snackbar:state.account.snackbar,
    refresh:state.account.refresh
  }
}

function dd(dispatch){
  return{
    setSnackbar:(message, type=undefined, icon=undefined)=>{dispatch({type:'SET_SNACKBAR', val:{open:(message==undefined)?false:true, message:message, type:type, icon:icon, anchorEl:undefined, onClick:undefined}})}
  }
}
